module.exports = __webpack_public_path__ + "img/certificate-CU-basic.06fd9566.jpg";